import React, { useState, useEffect } from "react";
import {
  deleteChannelLanguage,
  deleteLanguage,
  getAllChannelLanguage,
  updateChannelLanguage,
  updateLanguage,
} from "../../Components/service/admin";
import { Snackbar } from "@mui/material";
import { snackbar } from "../../utils";
import { useNavigate } from "react-router-dom";

const ChannelLanguageList = () => {
  const navigate = useNavigate();
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    fetchAllLanguages();
  }, []);

  async function fetchAllLanguages() {
    const result = await getAllChannelLanguage();

    if (result.data.error == false) {
      setLanguages(result?.data?.data);
    }
  }

  async function deleteLanguage(id) {
    const result = await deleteChannelLanguage(id);
    console.log("result", result);
    if (result.data.error == false) {
      setSuccess("Language deleted successfully");
      fetchAllLanguages();
    } else {
      setError(
        result?.data?.data?.errorMessage || "issue while detele language"
      );
    }
  }

  async function updateLanguage(id, data) {
    navigate("/add-channel-language", {
      state: {
        editMode: true,
        languageData: data,
        languageId: id,
      },
    });
  }

  function setError(message) {
    snackbar.error(message);
  }
  function setSuccess(message) {
    snackbar.success(message);
  }
  return (
    <div style={{ padding: "20px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ margin: 0, color: "#333" }}>Channel Languages</h2>
        <button
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
            transition: "background-color 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#0056b3";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#007bff";
          }}
          onClick={() => navigate("/add-channel-language")}
        >
          Add Language
        </button>
      </div>
      {languages.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "#666",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
          }}
        >
          No languages found
        </div>
      ) : (
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            overflow: "hidden",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f8f9fa" }}>
                <th
                  style={{
                    padding: "16px",
                    textAlign: "left",
                    fontWeight: "600",
                    color: "#333",
                    borderBottom: "2px solid #dee2e6",
                  }}
                >
                  S.No
                </th>
                <th
                  style={{
                    padding: "16px",
                    textAlign: "left",
                    fontWeight: "600",
                    color: "#333",
                    borderBottom: "2px solid #dee2e6",
                  }}
                >
                  Language Name
                </th>
                <th
                  style={{
                    padding: "16px",
                    textAlign: "left",
                    fontWeight: "600",
                    color: "#333",
                    borderBottom: "2px solid #dee2e6",
                  }}
                >
                  Language English Name
                </th>
                <th
                  style={{
                    padding: "16px",
                    textAlign: "center",
                    fontWeight: "600",
                    color: "#333",
                    borderBottom: "2px solid #dee2e6",
                  }}
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {languages.map((language, index) => (
                <tr
                  key={language._id}
                  style={{
                    transition: "background-color 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                >
                  <td
                    style={{
                      padding: "16px",
                      borderBottom: "1px solid #dee2e6",
                      color: "#666",
                    }}
                  >
                    {index + 1}
                  </td>
                  <td
                    style={{
                      padding: "16px",
                      borderBottom: "1px solid #dee2e6",
                      color: "#333",
                      fontWeight: "500",
                    }}
                  >
                    {language.name}
                  </td>
                  <td
                    style={{
                      padding: "16px",
                      borderBottom: "1px solid #dee2e6",
                      color: "#666",
                      fontFamily: "monospace",
                      fontSize: "14px",
                    }}
                  >
                    {language.englishName}
                  </td>
                  <td
                    style={{
                      padding: "16px",
                      borderBottom: "1px solid #dee2e6",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        justifyContent: "center",
                      }}
                    >
                      <button
                        style={{
                          padding: "6px 12px",
                          backgroundColor: "#007bff",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "12px",
                          transition: "background-color 0.2s ease",
                        }}
                        onClick={() => updateLanguage(language?._id, language)}
                      >
                        Edit
                      </button>
                      <button
                        style={{
                          padding: "6px 12px",
                          backgroundColor: "#dc3545",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "12px",
                          transition: "background-color 0.2s ease",
                        }}
                        onClick={() => {
                          deleteLanguage(language?._id);
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ChannelLanguageList;
